import React from 'react';
import cx from 'classnames';
import styles from './Sidebar.module.scss';
import { CustomButton } from '../../Button/Button';
import { Icon } from '../../Icon';

export default function MiniTrigger(props) {
  const { className, mini, toggle, menuSite, ...rest } = props;
  return (
    <CustomButton
      className={cx(className, styles.miniTrigger, styles[menuSite], { [styles.miniSidebar]: mini })}
      variant={'link'}
      {...rest}
      onClick={toggle}
      ariaLabel={mini ? 'Expand' : 'Collapse'}
    >
      <Icon src="mini_trigger" verticalAlign="middle" className={styles.icon} />
    </CustomButton>
  );
}
